import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getNotification } from '../../../api/get/getNotification';

import '../style/NewDetialInfo.css';

import calendar_icon from '../../../assets/icons/calendar.svg';
import share_icon from '../../../assets/icons/share.svg';
import { t } from 'i18next';
import Loading from '../../../common/components/Loading';

import formatDate from '../../../utils/formatDate';

function NewDetialInfo() {
    const { service, id } = useParams();
    const [data, setData] = useState(null);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await getNotification({ service, id });
                setData(response);
            } catch (error) {
                console.error("Error fetching notification:", error);
            }
        }

        fetchData();
    }, [service, id]);

    const handleShare = () => {
        if (navigator.share) {
            navigator.share({
                title: data.title,
                text: data.title,
                url: window.location.href,
            }).catch((error) => console.error('Share failed:', error));
        } else {
            alert('Браузер бөлісу функциясын қолдамайды.');
        }
    };

    const getImageSrc = () => {
        const f = data?.file;
        if (!f) return null;
        if (f.startsWith('data:')) return f;
        if (f.startsWith('http://') || f.startsWith('https://')) return f;
        return `data:image/jpeg;base64,${f}`;
    };

    if (!data) {
        return <Loading />;
    }

    const imageSrc = getImageSrc();

    return (
        <div className="news-card">
            <div className="news-meta">
                <div className="news-date">
                    <img src={calendar_icon} alt="calendar" className="icon" />
                    <span>{t('publishedAt')} {formatDate(data.created_at)}</span>
                </div>
                <div className="news-share" onClick={handleShare} style={{ cursor: 'pointer' }}>
                    <img src={share_icon} alt="share" className="icon" />
                    <span>{t('share')}</span>
                </div>
            </div>

            <h1 className="news-title">{data.title}</h1>

            {imageSrc && (
                <img
                    src={imageSrc}
                    alt={data.title}
                    className="news-image"
                />
            )}

            <div className="news-content" dangerouslySetInnerHTML={{ __html: data.text }} />
        </div>
    );
}

export default NewDetialInfo;